/**
 * @desc        Weather Reducer
 * @version     1.1 - 1 Feb 22 **/

import * as actionTypes from '../actions/action-types.js'

const initialState = {
    lastFetch: 0,
    loading: false,
}

const weather = (state = initialState, action) => {
    const { data, error, type } = action || {}
    switch (type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }
        case actionTypes.WEATHER_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                lastFetch: Date.now(),
                data: data,
            }
        case actionTypes.WEATHER_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.WEATHER_REQUEST_FAILURE:
            return {
                ...state,
                loading: false,
                error: error,
                lastError: Date.now(),
            }
        case actionTypes.WEATHER_CACHE:
            return state
        default: {
            return state
        }
    }
}

export default weather
